module.exports = __webpack_public_path__ + "img/along-the-river.61b9f82a.jpg";